<template>
  <div class="ricerca col-24 no-padding">
    <ricerca-panel :filtri="filtriRicerca" @closeRicerca="closeRicerca" @changeValueOrClick="changeValueOrClick"
      @cerca="cerca"></ricerca-panel>
  </div>
</template>

<script>
import RicercaPanel from '@/components/ServiceComponents/RicercaPanel'
import { bus } from '../Bus.js'

export default {
  name: 'Ricerca',
  components: { RicercaPanel },
  props: ['tipoRicerca'],
  i18n: {
    messages: {
      it_IT: {
        ricerca: {
          filtri: 'Filtri',
          startDate: 'Data Inizio',
          endDate: 'Data Fine',
          destination: 'Destinazione',
          employee: 'Dipendente',
          daGestire: 'Da Gestire',
          status: 'Stato',
          cerca: 'Cerca',
          scegli: 'Scegli...'
        }
      },
      fr_FR: {
        ricerca: {
          filtri: 'Filtres',
          startDate: 'Date du',
          endDate: 'Date au',
          destination: 'Destination',
          employee: 'Salarié',
          daGestire: 'À gérer',
          status: 'Etat',
          cerca: 'Rechercher',
          scegli: 'Choisir...'
        }
      },
      es_ES: {
        ricerca: {
          filtri: 'Filtros',
          startDate: 'Dia salida',
          endDate: 'Dia regreso',
          destination: 'Destino',
          employee: 'Empleado',
          daGestire: 'Para gestionar',
          status: 'Estado',
          cerca: 'Búsqueda',
          scegli: 'Elegir...'
        }
      },
      de_DE: {
        ricerca: {
          filtri: 'Filter',
          startDate: 'Reisebeginn',
          endDate: 'Reiseende',
          destination: 'Reiseziel',
          employee: 'Mitarbeiter',
          daGestire: 'zum Bearbeiten',
          status: 'Land',
          cerca: 'Suche',
          scegli: 'Wählen...'
        }
      },
      en_GB: {
        ricerca: {
          filtri: 'Filters',
          statoNazione: 'Country',
          codForn: 'Supplier Code',
          societa: 'Society',
          stabilimento: 'Establishment',
          anno: 'Year',
          nrOrdine: 'Nr. Order',
          cerca: 'Search',
          scegli: 'Choose...'
        }
      }
    }
  },
  data() {
    return {
      firstLoad: true,
      filtriRicerca: {
        loading: true,
        titolo: '',
        valueSelected: {
          0: '',
          1: '',
          2: 'all',
          3: '',
          4: '',
          5: true
        },
        dati: {
          2: [
            { id: 'all', desc: this.$t('status.all') },
            { id: '0', desc: this.$t('status.0') },
            { id: '1', desc: this.$t('status.1') },
            { id: '2', desc: this.$t('status.2') },
            { id: '3', desc: this.$t('status.3') },
            { id: '4', desc: this.$t('status.4') },
            { id: '7', desc: this.$t('status.7') }
          ],
          3: [],
          4: []
        },
        filtri: [
          // Select con le country a cui è abilitato l'utente
          {
            type: 'dt-picker',
            myLabel: '',
            ifClearable: true,
            typePicker: 'date',
            format: 'dd/MM/yyyy',
            valueFormat: 'yyyyMMdd'
          },
          {
            type: 'dt-picker',
            myLabel: '',
            ifClearable: true,
            typePicker: 'date',
            format: 'dd/MM/yyyy',
            valueFormat: 'yyyyMMdd'
          },
          {
            type: 'select',
            myLabel: '',
            value: 'id',
            label: 'desc',
            key: 'id',
            ifClearable: true,
            ifDisabled: false
          },
          {
            type: 'select',
            myLabel: '',
            value: 'id',
            label: 'desc',
            key: 'id',
            ifClearable: true,
            ifDisabled: false
          },
          {
            type: 'select',
            myLabel: '',
            value: 'ccDipendente',
            label: 'employee',
            key: 'ccDipendente',
            ifClearable: true,
            ifDisabled: false
          },
          {
            type: 'checkbox',
            myLabel: ''
          }
        ]
      }
    }
  },
  mounted: function () {
    this.initialize()
  },
  activated: function () {
    this.initialize()
  },
  watch: {
    'filtriRicerca.valueSelected.1': function (newVal, oldVal) {
      if (this.firstLoad === false) {
        this.filtriRicerca.dati[2] = []
        this.filtriRicerca.dati[3] = []
        this.filtriRicerca.dati[4] = []
        this.filtriRicerca.valueSelected[2] = ''
        this.filtriRicerca.valueSelected[3] = ''
        this.filtriRicerca.valueSelected[4] = ''
        this.filtriRicerca.filtri[2].ifDisabled = true
        this.filtriRicerca.filtri[3].ifDisabled = true
        this.filtriRicerca.filtri[4].ifDisabled = true
      }
    }
  },
  methods: {
    initialize: function () {
      this.getStabilimenti()
      if (this.tipoRicerca === 'Trasferte_Aut_form') {
        this.getTrasfertisti()
      } else {
        this.filtriRicerca.filtri.splice(4, 2);
      }
      this.$nextTick(() => {
        if (sessionStorage.hasOwnProperty(this.tipoRicerca)) {
          let form = JSON.parse(sessionStorage.getItem(this.tipoRicerca))
          this.filtriRicerca.valueSelected[0] = form.dataDal
          this.filtriRicerca.valueSelected[1] = form.dataAl
          this.filtriRicerca.valueSelected[2] = form.statoAvanz
          this.filtriRicerca.valueSelected[3] = form.destinazione
          if (this.tipoRicerca === 'Trasferte_Aut_form') {
            this.filtriRicerca.valueSelected[4] = form.employee
            this.filtriRicerca.valueSelected[5] = form.daGestire === undefined ? true : form.daGestire
          }
        }
        bus.$on('changeLanguage', () => {
          this.$nextTick(() => {
            this.setTraduzioniLabel()
          })
        })
        this.setTraduzioniLabel()
      })
    },
    setTraduzioniLabel: function () {
      this.$set(this.filtriRicerca, 'titolo', this.$t('ricerca.filtri'))
      this.$set(this.filtriRicerca.filtri[0], 'myLabel', this.$t('ricerca.startDate'))
      this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.endDate'))
      this.$set(this.filtriRicerca.filtri[2], 'myLabel', this.$t('ricerca.status'))
      this.$set(this.filtriRicerca.filtri[3], 'myLabel', this.$t('ricerca.destination'))
      if (this.tipoRicerca === 'Trasferte_Aut_form') {
        this.$set(this.filtriRicerca.filtri[4], 'myLabel', this.$t('ricerca.employee'))
        this.$set(this.filtriRicerca.filtri[5], 'myLabel', this.$t('ricerca.daGestire'))
      }

      this.filtriRicerca.dati[2] = [
        { id: 'all', desc: this.$t('status.all') },
        { id: '0', desc: this.$t('status.0') },
        { id: '1', desc: this.$t('status.1') },
        { id: '2', desc: this.$t('status.2') },
        { id: '3', desc: this.$t('status.3') },
        { id: '4', desc: this.$t('status.4') },
        { id: '7', desc: this.$t('status.7') }
      ]
    },
    closeRicerca: function () {
      this.$emit('closeRicerca')
    },
    cerca: function () {
      let form = {
        dataDal: this.filtriRicerca.valueSelected[0],
        dataAl: this.filtriRicerca.valueSelected[1],
        statoAvanz: this.filtriRicerca.valueSelected[2],
        destinazione: this.filtriRicerca.valueSelected[3]
      }
      if (this.tipoRicerca === 'Trasferte_Aut_form') {
        form['ccDipendente'] = this.filtriRicerca.valueSelected[4];
        form['daGestire'] = this.filtriRicerca.valueSelected[5];
      }
      this.$emit('cerca', JSON.stringify(form))
    },
    changeValueOrClick: function (index) {
      if (this.filtriRicerca.filtri[index].hasOwnProperty('onChangeOrClick')) {
        this[this.filtriRicerca.filtri[index].onChangeOrClick]()
      }
    },
    getStabilimenti: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/gensta')
        .then(response => {
          if (response.body.rc === 0) {
            this.filtriRicerca.dati[3] = response.body.data
            //this.cerca()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.filtriRicerca.loading = false
        })
    },
    getTrasfertisti: function () {
      this.$http.get('trasferte/' + this.$store.state.country + '/trasfertisti')
        .then(response => {
          if (response.body.rc === 0) {

            this.filtriRicerca.dati[4] = response.body.data.map(function (obj) {
              obj.employee = obj.cognome + ' ' + obj.nome
              return obj
            })
            //this.filtriRicerca.dati[4] = response.body.data
            //this.cerca()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.filtriRicerca.loading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../assets/less/general.less";

.ricerca {
  height: 100%;
  position: absolute;
  z-index: 10;

  .header-tab {
    height: 65px;
    border-bottom: 1px solid #007c74;
    text-align: center;

    .icon-search {
      line-height: 65px;

      .el-button {
        height: 40px;
        width: 40px;
        border-radius: 0px;
        margin-top: 12px;
        margin-left: 10px;
        padding: 0px;
        color: @greenRiva;
        float: left;
        border: 1px solid @greenRiva;
      }

      .el-button:hover {
        background-color: @white;
      }
    }
  }

  .el-table::before {
    height: 0px;
  }

  .el-table {
    border-bottom: none;
    height: 430px;
    overflow: auto;

    .el-table__fixed-right {
      box-shadow: none;
      -webkit-box-shadow: none;

      .el-table__fixed-body-wrapper {
        top: 41px;
      }
    }

    .el-table__fixed-right::before {
      height: 0px;
    }

    .el-table__header {
      border-bottom: 1px solid @greenRiva;

      thead {
        th {
          padding: 5px 0px 0px 0px;

          &:not(.is-sortable) {
            .cell {
              margin-top: -7px;
            }
          }

          .cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-left: 10px !important;
            .set-font(@color: @greenRiva; @weight: bold; @size: 12px);
          }
        }
      }
    }

    .el-table__body {
      tbody {
        tr {
          &.expanded {
            background-color: #e7e7e7;

            td {
              background-color: #e7e7e7 !important;
            }
          }

          &.hover-row {
            td {
              background-color: @white;
            }
          }

          &.single {
            .el-table__expand-icon {
              display: none;
            }
          }

          td {
            padding-top: 5px;
            padding-bottom: 5px;

            .cell {
              .set-font(@size: 13px; @color: #606266);

              .pointer:hover {
                cursor: pointer;
              }

              .fa-icon {
                margin-top: 4px;
              }
            }

            -webkit-transition: none;
            transition: none;
          }

          .el-table__expanded-cell {
            padding: 0px !important;

            .el-table__header-wrapper {
              display: none;
            }

            .el-table {
              height: auto !important;

              .el-table__body {
                tr {
                  td {
                    border-bottom: 0px;

                    &.cella-evidenziata {
                      background-color: #e7e7e7;
                    }
                  }
                }
              }
            }

            .el-table::before {
              height: 0px;
            }

            .el-table__empty-block {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Trasferte/Ricerca.vue